export default [
  { value: "Mr.", label: "Mr." },
  { value: "Miss", label: "Miss" },
  { value: "Mrs.", label: "Mrs." },
  { value: "Ms.", label: "Ms." },
  { value: "1st. Lt.", label: "1st. Lt." },
  { value: "2nd. Lt.", label: "2nd. Lt." },
  { value: "A/2C", label: "A/2C" },
  { value: "A/1C", label: "A/1C" },
  { value: "Admiral", label: "Admiral" },
  { value: "Ambassador", label: "Ambassador" },
  { value: "AOC", label: "AOC" },
  { value: "Asst. Prof.", label: "Asst. Prof." },
  { value: "Bishop", label: "Bishop" },
  { value: "Brig. Gen.", label: "Brig. Gen." },
  { value: "Capt.", label: "Capt." },
  { value: "Cardinal", label: "Cardinal" },
  { value: "Cdr.", label: "Cdr." },
  { value: "Chaplain", label: "Chaplain" },
  { value: "Chief Judge", label: "Chief Judge" },
  { value: "Cmdr.", label: "Cmdr." },
  { value: "CMSgt.", label: "CMSgt." },
  { value: "Col.", label: "Col." },
  { value: "Col. & Mrs.", label: "Col. & Mrs." },
  { value: "Consul General", label: "Consul General" },
  { value: "Congressman", label: "Congressman" },
  { value: "Crown Prince", label: "Crown Prince" },
  { value: "CSM Ret.", label: "CSM Ret." },
  { value: "CWO", label: "CWO" },
  { value: "Dean", label: "Dean" },
  { value: "Dr.", label: "Dr." },
  { value: "Ensign", label: "Ensign" },
  { value: "The Estate of", label: "The Estate of" },
  { value: "Father", label: "Father" },
  { value: "General", label: "General" },
  { value: "Governor", label: "Governor" },
  { value: "His Holiness", label: "His Holiness" },
  { value: "Judge", label: "Judge" },
  { value: "Judge & Mrs.", label: "Judge & Mrs." },
  { value: "Justice", label: "Justice" },
  { value: "Lcdr.", label: "Lcdr." },
  { value: "Lt.", label: "Lt." },
  { value: "Lt. Col.", label: "Lt. Col." },
  { value: "Lt. Col. & Mrs.", label: "Lt. Col. & Mrs." },
  { value: "Lt. Gen.", label: "Lt. Gen." },
  { value: "LTJG", label: "LTJG" },
  { value: "Maj.", label: "Maj." },
  { value: "Maj. & Mrs.", label: "Maj. & Mrs." },
  { value: "Maj. Gen.", label: "Maj. Gen." },
  { value: "Mayor", label: "Mayor" },
  { value: "Mme.", label: "Mme." },
  { value: "Monsignor", label: "Monsignor" },
  { value: "Mother", label: "Mother" },
  { value: "Mr. & Mrs.", label: "Mr. & Mrs." },
  { value: "MSgt.", label: "MSgt." },
  { value: "Mx.", label: "Mx." },
  { value: "Pastor", label: "Pastor" },
  { value: "PFC", label: "PFC" },
  { value: "PO2", label: "PO2" },
  { value: "President", label: "President" },
  { value: "Prof.", label: "Prof." },
  { value: "Rabbi", label: "Rabbi" },
  { value: "Rear Adm.", label: "Rear Adm." },
  { value: "Representative", label: "Representative" },
  { value: "Reverend Friar", label: "Reverend Friar" },
  { value: "Right Reverend", label: "Right Reverend" },
  { value: "Secretary", label: "Secretary" },
  { value: "Senator", label: "Senator" },
  { value: "SFC Ret.", label: "SFC Ret." },
  { value: "Sgt.", label: "Sgt." },
  { value: "Sheikh", label: "Sheikh" },
  { value: "Sheikha", label: "Sheikha" },
  { value: "Sir", label: "Sir" },
  { value: "Sister", label: "Sister" },
  { value: "SP/4", label: "SP/4" },
  { value: "The Honorable", label: "The Honorable" },
  { value: "The Most Reverend", label: "The Most Reverend" },
  { value: "The Rev.", label: "The Rev." },
  { value: "The Rev. Col.", label: "The Rev. Col." },
  { value: "The Rev. Dr.", label: "The Rev. Dr." },
  { value: "The Very Reverend", label: "The Very Reverend" },
  { value: "TSgt.", label: "TSgt." },
];
